'use client';

import { useEffect, useState } from 'react';

import { disablePostHog, loadPostHog, posthogAllowed } from '@/lib/posthog';

/**
 * Mounts PostHog (for the post-first-scan feedback survey) only after the user
 * has granted analytics consent. Mirrors `BetterStackConsentLoader`: it reacts
 * to consent changes via the `storage` and `purebox:consent-changed` events.
 */
export function PostHogConsentLoader() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const sync = () => setEnabled(posthogAllowed());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('purebox:consent-changed', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('purebox:consent-changed', sync);
    };
  }, []);

  useEffect(() => {
    if (!enabled) {
      disablePostHog();
      return;
    }
    void loadPostHog();
  }, [enabled]);

  return null;
}
